export default __webpack_public_path__ + "static/media/metallic-prints-frame.df39878f.jpg";